import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from './SessionContext';

const cardStyle = {
  maxWidth: 760,
  margin: '3rem auto',
  background: '#181a2a',
  borderRadius: 16,
  padding: '2rem',
  color: '#eaf6ff',
  boxShadow: '0 4px 32px rgba(0,0,0,0.18)',
};

const buttonStyle = {
  background: '#b6eaff',
  color: '#181a2a',
  border: 'none',
  borderRadius: 8,
  padding: '0.6rem 1rem',
  fontWeight: 700,
  cursor: 'pointer',
};

export default function ContactPage() {
  const navigate = useNavigate();
  const session = useSession();

  return (
    <div style={cardStyle}>
      <h2 style={{ color: '#1ecfff', fontWeight: 700, fontSize: '2rem', marginBottom: '1rem' }}>Contact Wingit</h2>
      <p style={{ color: '#b6eaff', lineHeight: 1.7, marginBottom: '1rem' }}>
        Need help with bookings, setup, account access, or becoming a member? Reach out and we will help.
      </p>
      <div style={{ lineHeight: 1.9, marginBottom: '1.2rem' }}>
        <div><strong>Email:</strong> <a href="mailto:owner@demo.wingit.app" style={{ color: '#9fdcff' }}>owner@demo.wingit.app</a></div>
        <div><strong>Support:</strong> Include your name, aircraft registration, and booking date if relevant.</div>
      </div>
      <button
        type="button"
        onClick={() => navigate(session ? '/dashboard' : '/register')}
        style={buttonStyle}
      >
        Back
      </button>
    </div>
  );
}
